import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';

import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import { AmenityIcon, InnerText } from '../styled';
import type { RestaurantDetailItem } from '../types';

interface ServiceAvailabilityItemsProps {
  items: RestaurantDetailItem[];
}

export const ServiceAvailabilityItems = ({ items }: ServiceAvailabilityItemsProps) => (
  <View style={styles.serviceAvailabilityList}>
    {items.map(({ icon, label, testID }, index) => (
      <View
        key={label.key}
        testID={testID}
        style={[
          styles.serviceAvailabilityItem,
          index < items.length - 1 && styles.serviceAvailabilityItemSpacing,
        ]}
      >
        <AmenityIcon
          variant={icon}
          size="$4"
          style={styles.serviceAvailabilityIcon}
          {...hiddenAccessibilityPlatformProps}
        />
        <InnerText numberOfLines={1} style={styles.serviceAvailabilityText}>
          {t(label.key, label.defaultMessage)}
        </InnerText>
        <Icon
          variant="check"
          size="$3"
          color={primitive.$bbqBrown}
          {...hiddenAccessibilityPlatformProps}
        />
      </View>
    ))}
  </View>
);

const styles = StyleSheet.create({
  serviceAvailabilityList: {
    flexDirection: 'row',
  },
  serviceAvailabilityItem: {
    alignItems: 'center',
    borderColor: primitive.$bbqBrownOpacity20,
    borderRadius: 4,
    borderWidth: 1,
    flex: 1,
    flexDirection: 'row',
    minHeight: 30,
    paddingHorizontal: 8,
  },
  serviceAvailabilityItemSpacing: {
    marginRight: 8,
  },
  serviceAvailabilityIcon: {
    marginRight: 6,
  },
  serviceAvailabilityText: {
    flex: 1,
    marginRight: 4,
  },
});
